<ul class="table-dropdown all-invoices-dropdown" [ngClass]="{'opened' : isActive}">
	<li *ngFor="let menu of menuItems" [hidden]="!menu.visible || (itemSelected.length > 1 && menu.singleOnly)">
        <a class="cursor-pointer" (click)="menu.onClick(itemSelected);menuClicked.emit()">{{menu.label}}</a>
    </li>
</ul>